<template>
  <div class="my-3 py-2 container-fluid">
    <button
      v-if="lastSeason"
      @click="showCreateForm"
      class="mb-3 btn btn-sm btn-outline-success"
    >
      {{ $t("subcourses.createSubcourse") }}
    </button>
    <div class="row">
      <transition name="slide-fade" class="my-4">
        <form-create-subcourse
          v-if="isCreateSubcourseVisible"
          @fetch-subcourses="fetchSubcourses"
          @close="hideCreateForm"
        />
      </transition>
      <div class="col-12">
        <SubcourseList
          :subcourses="subcourses"
          :lastSeason="lastSeason"
          :isEditFormVisible="isEditFormVisible"
          @formSubmitted="hideChild"
          @fetch-subcourses="fetchSubcourses"
          @hide-create-form="hideEditForm"
        />
      </div>
    </div>
    <soft-pagination color="success" size="sm">
      <soft-pagination-item
        prev
        @click="prevPage"
        :disabled="currentPage === 1"
      />
      <div v-for="item in totalPages" :key="item">
        <soft-pagination-item
          v-if="item == currentPage"
          :label="currentPage"
          active
        />
        <soft-pagination-item
          v-if="item != currentPage"
          :label="item"
          @click="currPage(item)"
        />
      </div>
      <soft-pagination-item
        next
        @click="nextPage"
        :disabled="currentPage === totalPages"
      />
    </soft-pagination>
  </div>
</template>

<script>
import SubcourseList from "./components/SubcourseList";
import axios from "axios";
import SoftPagination from "@/components/SoftPagination.vue";
import SoftPaginationItem from "@/components/SoftPaginationItem.vue";
import FormCreateSubcourse from "@/components/FormCreateSubcourse";

export default {
  name: "subcourses",
  components: {
    SubcourseList,
    SoftPagination,
    SoftPaginationItem,
    FormCreateSubcourse,
  },
  data() {
    return {
      subcourses: [],
      currentPage: 1,
      totalPages: 1,
      isCreateSubcourseVisible: false,
      isEditFormVisible: false,
      lastSeason: false,
    };
  },
  created() {
    this.fetchSubcourses();
  },
  methods: {
    setSubcources(subcourses) {
      this.subcourses = subcourses;
    },
    async fetchSubcourses(page = 1) {
      const response = await axios.get(`subcourses?page=${page}`);
      this.subcourses = response.data.subcourses;
      this.currentPage = response.data.meta.current_page;
      this.totalPages = response.data.meta.last_page;
      this.lastSeason = response.data.last_season;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchSubcourses(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchSubcourses(this.currentPage);
      }
    },
    currPage(item) {
      this.currentPage = item;
      this.fetchSubcourses(item);
    },
    showCreateForm() {
      this.isCreateSubcourseVisible = true;
      this.isEditFormVisible = false;
    },
    hideCreateForm() {
      this.isCreateSubcourseVisible = false;
      this.isEditFormVisible = false;
    },
    hideEditForm() {
      this.isCreateSubcourseVisible = false;
      this.isEditFormVisible = true;
    },
    hideChild() {
      this.isCreateSubcourseVisible = false;
      this.isEditFormVisible = true;
      this.fetchSubcourses();
    },
    subcourseCreated() {
      this.isCreateSubcourseVisible = false;
      this.fetchSubcourses();
    },
  },
};
</script>
